import React from "react";
import styles from "../../pages/login/login.module.css";

interface SSOLoginButtonProps {
  onClick: () => void;
  t: (key: string) => string;
}

export const SSOLoginButton: React.FC<SSOLoginButtonProps> = ({ onClick, t }) => {
  return (
    <button className={styles.loginButton} onClick={onClick}>
      {t("Common.login")}
    </button>
  );
};
